import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { CleanPatternsForm } from './clean-patterns-form';
import { CleanPatternsListing } from './clean-patterns-listing';

export const CleanPatternsRouter: React.FC = () => (
    <Switch>
        <Route exact path='/cris/clean-patterns' component={CleanPatternsListing} />
        <Route exact path='/cris/clean-patterns/new/create' component={CleanPatternsForm} />
        <Route exact path='/cris/clean-patterns/:id/edit' component={CleanPatternsForm} />
    </Switch>
);
